import { __awaiter } from 'tslib';
import 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseApiManager } from '../../core/plugin/BaseApiManager.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../core/network/NetworkItem.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';
import { MultimediaPluginConsts } from '../interfaces.js';

class MultimediaApiManager extends BaseApiManager {
    GetMediaUploadToken(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_upload_token_body: {
                    vsdk_version: MultimediaPluginConsts.vsdkVersion,
                    token_type: type
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_MEDIA_UPLOAD_TOKEN)).get_upload_token_body;
        });
    }
    GetMediaUrls(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_media_urls_body: {
                    source_appid: params.sourceAppId,
                    uri: params.uri,
                    media_type: params.mediaType,
                    encrypted: params.encrypted,
                    img_options: params.imgOptions ? params.imgOptions.map(m => im_proto.ImgOption.create({
                        tplv: m.tplv,
                        params: m.params,
                        format: m.format,
                        urls: m.urls
                    })) : undefined,
                    video_options: params.videoOptions ? params.videoOptions.map(m => im_proto.VideoOption.create({
                        vid: m.vid,
                        cover_uri: m.coverUri,
                        urls: m.urls,
                        cover_urls: m.coverUrls
                    })) : undefined,
                    audio_options: params.audioOptions ? params.audioOptions.map(m => im_proto.AudioOption.create({
                        vid: m.vid,
                        urls: m.urls
                    })) : undefined,
                    file_options: params.fileOptions ? params.fileOptions.map(m => im_proto.FileOption.create({
                        urls: m.urls
                    })) : undefined,
                    read_url_from: params.mediaType === im_proto.MediaType.IMG ? im_proto.ReadURLFrom.URL_IMAGEX : im_proto.ReadURLFrom.URL_VSDK,
                    encrypted_uri: params.encryptedUri
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MEDIA_URLS);
        });
    }
}

export { MultimediaApiManager };
//# sourceMappingURL=MultimediaApiManager.js.map
